/* ============================================================
   IGNITE — AGE GATE (logica)
   Verifica daca utilizatorul a confirmat varsta in sesiunea
   curenta. Daca nu, afiseaza popup-ul. Sub 18 ani => redirect.
   Vanilla JS, fara dependente.
   ============================================================ */

(function () {
  'use strict';

  var KEY = 'ignite_age_verified';     // cheia in sessionStorage
  var MIN_AGE = 18;
  var REDIRECT_URL = 'https://www.google.com';

  // ----------- Verificam daca a fost deja confirmat in sesiune -----------
  try {
    if (sessionStorage.getItem(KEY) === '1') {
      // Era confirmat deja. Nu facem nimic.
      return;
    }
  } catch (e) {
    // sessionStorage nu e disponibil (mod privat in unele browsere).
    // Continuam si afisam popup-ul oricum.
  }

  // ----------- Pornim cand DOM-ul e gata -----------
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var gate = document.getElementById('age-gate');
    if (!gate) return;

    var form    = document.getElementById('age-gate-form');
    var dayEl   = document.getElementById('age-gate-day');
    var monthEl = document.getElementById('age-gate-month');
    var yearEl  = document.getElementById('age-gate-year');
    var errorEl = document.getElementById('age-gate-error');
    var denied  = document.getElementById('age-gate-denied');

    // Blocam scroll-ul si afisam popup-ul
    document.body.classList.add('age-gate-locked');
    gate.hidden = false;

    // Focus pe primul camp dupa o mica intarziere
    setTimeout(function () {
      if (dayEl) dayEl.focus();
    }, 100);

    // ----------- Helper: doar cifre in input -----------
    function digitsOnly(input) {
      input.addEventListener('input', function () {
        var clean = input.value.replace(/\D/g, '');
        if (clean !== input.value) {
          input.value = clean;
        }
        input.classList.remove('is-invalid');
      });
    }
    digitsOnly(dayEl);
    digitsOnly(monthEl);
    digitsOnly(yearEl);

    // ----------- Auto-jump intre campuri -----------
    dayEl.addEventListener('input', function () {
      if (dayEl.value.length === 2) monthEl.focus();
    });
    monthEl.addEventListener('input', function () {
      if (monthEl.value.length === 2) yearEl.focus();
    });

    // Backspace pe camp gol => sari inapoi
    monthEl.addEventListener('keydown', function (e) {
      if (e.key === 'Backspace' && monthEl.value === '') dayEl.focus();
    });
    yearEl.addEventListener('keydown', function (e) {
      if (e.key === 'Backspace' && yearEl.value === '') monthEl.focus();
    });

    // ----------- Afiseaza eroare -----------
    function showError(msg, field) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
      if (field) field.classList.add('is-invalid');
    }
    function clearError() {
      errorEl.textContent = '';
      errorEl.hidden = true;
      [dayEl, monthEl, yearEl].forEach(function (el) {
        el.classList.remove('is-invalid');
      });
    }

    // ----------- Validare data + calcul varsta -----------
    function isValidDate(y, m, d) {
      var date = new Date(y, m - 1, d);
      return date.getFullYear() === y && date.getMonth() === (m - 1) && date.getDate() === d;
    }

    function calculateAge(y, m, d) {
      var today = new Date();
      var age = today.getFullYear() - y;
      var monthDiff = today.getMonth() - (m - 1);
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < d)) {
        age--;
      }
      return age;
    }

    // ----------- Submit -----------
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var d = parseInt(dayEl.value, 10);
      var m = parseInt(monthEl.value, 10);
      var y = parseInt(yearEl.value, 10);

      // verificari de baza
      if (!d || !m || !y) {
        showError('Te rugăm să completezi data nașterii complet.', !d ? dayEl : (!m ? monthEl : yearEl));
        return;
      }
      if (d < 1 || d > 31) {
        showError('Ziua trebuie să fie între 1 și 31.', dayEl);
        return;
      }
      if (m < 1 || m > 12) {
        showError('Luna trebuie să fie între 1 și 12.', monthEl);
        return;
      }
      if (y < 1900 || y > new Date().getFullYear()) {
        showError('Anul nu este valid.', yearEl);
        return;
      }
      if (!isValidDate(y, m, d)) {
        showError('Data introdusă nu este o dată calendaristică validă.', dayEl);
        return;
      }

      var age = calculateAge(y, m, d);

      if (age >= MIN_AGE) {
        // ACCES PERMIS
        try {
          sessionStorage.setItem(KEY, '1');
        } catch (err) { /* ignoram */ }

        // Ascundem popup-ul cu o mica tranzitie
        gate.hidden = true;
        document.body.classList.remove('age-gate-locked');
      } else {
        // ACCES INTERZIS — afisam ecranul "denied"
        form.hidden = true;
        denied.hidden = false;

        // Incercam si un redirect automat dupa o scurta pauza
        // (utilizatorul vede mesajul, apoi e redirectat)
        setTimeout(function () {
          // Folosim replace ca sa nu poata da "back" la site
          window.location.replace(REDIRECT_URL);
        }, 2500);
      }
    });

    // ----------- Butonul "Intoarce-te" (linkul deja are href, dar interceptam ca sa folosim replace) -----------
    var backBtn = document.getElementById('age-gate-back');
    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.replace(REDIRECT_URL);
      });
    }
  });
})();
